import React from 'react'
import { TextInput, Toggle, Divider } from '@/components/atoms'

/**
 * LoyaltyUrl component displays the Loyalty URL input field and coupon toggle
 * Used specifically for LOYALTY reward type after the preview message
 * 
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing loyaltyURL and couponBasedLoyaltyReward values
 * @param {Function} props.handleLoyaltyURLChange - Handler for loyalty URL input changes
 * @param {Function} props.handleCouponBasedLoyaltyRewardChange - Handler for coupon toggle changes
 * @param {string} props.loyaltyURLError - Error message for loyalty URL validation
 * @returns {JSX.Element} The rendered LoyaltyUrl component
 */
const LoyaltyUrl = ({
  formData,
  handleLoyaltyURLChange,
  handleCouponBasedLoyaltyRewardChange,
  loyaltyURLError,
}) => {
  return (
    <div className="mt-4 flex flex-col">
      <TextInput
        className='placeholder:text-sm text-sm'
        value={formData?.loyaltyURL || ''}
        onChange={handleLoyaltyURLChange}
        label="Loyalty URL*"
        placeholderText="Enter Loyalty URL"
        error={loyaltyURLError}
        isDark={true}
        type="text"
        id="loyalty-url"
      />
      <Divider />
      <Toggle
        value={formData?.couponBasedLoyaltyReward || false}
        updateValue={handleCouponBasedLoyaltyRewardChange}
        uiSchema={{
          label: 'Coupon based loyalty reward',
          isDark: true,
          size: 'medium',
        }}
        id="coupon-based-loyalty-reward"
      />
    </div>
  )
}

export default LoyaltyUrl
